import React from 'react';
import type { RfqReleasePurpose } from '../../types';
import { isReferenceRelease, RFQ_RELEASE_PURPOSE_HINTS } from '../../utils/rfqReleasePurpose';

/** "Reference" / "Quoting" badge for a staged release or published package. */
export const RfqReleasePurposeBadge: React.FC<{
  releasePurpose?: RfqReleasePurpose | null;
  /** Hide the Quoting badge (noise when every release quotes). */
  quoteSilent?: boolean;
}> = ({ releasePurpose, quoteSilent = false }) => {
  if (isReferenceRelease({ releasePurpose })) {
    return (
      <span
        className="srfq-timber-version-badge srfq-timber-version-badge--reference"
        title={RFQ_RELEASE_PURPOSE_HINTS.reference}
      >
        Reference — not requoted
      </span>
    );
  }
  if (quoteSilent) return null;
  return (
    <span
      className="srfq-timber-version-badge srfq-timber-version-badge--quoting"
      title={RFQ_RELEASE_PURPOSE_HINTS.quote}
    >
      Quoting
    </span>
  );
};

/** Which structures a release covers; empty = whole project. */
export const RfqReleaseStructureChips: React.FC<{
  structureNames?: ReadonlyArray<string> | null;
  prefix?: string;
}> = ({ structureNames, prefix = 'Covers' }) => {
  const names = (structureNames ?? []).map((n) => (n || '').trim()).filter(Boolean);
  return (
    <span className="srfq-release-scope" aria-label={`${prefix}: ${names.length ? names.join(', ') : 'all structures'}`}>
      <span className="srfq-release-scope-prefix">{prefix}</span>
      {names.length === 0 ? (
        <span className="srfq-release-scope-chip srfq-release-scope-chip--all">All structures</span>
      ) : (
        names.map((name) => (
          <span key={name} className="srfq-release-scope-chip">
            {name}
          </span>
        ))
      )}
    </span>
  );
};
